import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getAuth } from "firebase/auth";
 

//Access environment variables
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAUfFfbP6pzqjmIsAGrPJX_Qnn9zf-th08",
  authDomain: "unieros-react.firebaseapp.com",
  projectId: "unieros-react",
  storageBucket: "unieros-react.appspot.com",
  messagingSenderId: "1024289595776",
  appId: "1:1024289595776:web:cf7c1961accafac203a165",
  measurementId: "G-E6ZXBM626C"
};


  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  const db = getFirestore(app);
  const auth = getAuth(app);

// export sendSignInLinkToEmail
const sendSignInLinkToEmail = (email, emailLink) => {
  console.log("Sending sign-in link to email", email, emailLink);
  return auth
  .sendSignInLinkToEmail(email, emailLink)
  .then(( result) => {
    console.log("Sign-in with email link success", result);
    window.localStorage.removeItem("emailForSignIn");
    return result.user;
  })
  .catch((error) => {
    console.error("Error sending sign-in link to email", error);
    throw new Error("Failed to send sign-in link to email");
  });
};
export {app, db, auth, sendSignInLinkToEmail};



